import { styled } from '../../../utils/styled'
import type { CSSObject } from '../../theme/themeTypes'
import Tab from '@mui/material/Tab'
import { type IconTabSize } from './types'

export const StyledIconTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'size'
})<{ size?: IconTabSize }>(({ size, theme }): CSSObject => {
  const padding = size === 'small' ? '4px' : '8px'
  const minSize = size === 'small' ? '32px' : '40px'
  const borderRadius = size === 'small' ? theme.borderRadius.small : theme.borderRadius.medium

  return {
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'initial',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: minSize,
    minWidth: minSize,
    borderRadius,
    padding,
    color: theme.tokens.foreground.main.primary,
    '&.Mui-disabled': {
      color: theme.tokens.foreground.main.disabled
    }
  }
})

export const IconTabIconContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`
